import React, { Component } from "react";
import ReactQuill, { Quill } from "react-quill";
import { fetchPublicBlog } from "../../../actions/publicBlogActions";
import { connect } from "react-redux";
import "./Blog.css";
import NavbarClass from "../../NavbarClass";
import Footer from "../../footer/Footer";
import { localAPI } from "../../../api/local";
import { pageview } from "../../../utils/googleAnalyticsUtils";

class Blog extends Component {
  async componentDidMount() {
    pageview('Blog');
    if (!this.props.sample) {
      await this.props.fetchPublicBlog(this.props.match.params.publicBlogId);
    }
  }

  getPublicBlogContent(publicBlog) {
    return publicBlog?.content ? publicBlog.content : "";
  }

  render() {
    return (
      <div>
        <div className="blog-outer-container">
          {!this.props.sample && <NavbarClass />}
          <div className="container blog-container">
            <ReactQuill
              readOnly
              value={this.getPublicBlogContent(this.props.sample ? this.props.samplePublicBlog : this.props?.publicBlog)}
              modules={{ toolbar: null }}
              className="p-3"
            />
          </div>
          {!this.props.sample && (
            <Footer customStyles={{ position: "absolute", bottom: 0 }} />
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    publicBlog: state.publicBlogs?.publicBlog?.publicBlog,
    // userData: state.checkUser.userData,
    // type: state.type,
  };
};

export default connect(mapStateToProps, {
  fetchPublicBlog
})(Blog);
